import { useEffect } from 'react'
import { useQueryClient } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { beginCheckoutConfirmation, endCheckoutConfirmation } from '../../services/api/subscription.hooks'
import { toast } from '../molecules/toast'

const subscriptionReturnMessages: Record<string, string> = {
    success: 'Confirming subscription.',
    canceled: 'Checkout canceled.',
    portal_return: 'Billing updated.',
}

const SubscriptionReturnHandler = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const subscriptionReturn = searchParams.get('subscription')
        if (!subscriptionReturn) return

        queryClient.invalidateQueries('user_info')

        if (subscriptionReturn === 'success') {
            beginCheckoutConfirmation(queryClient)
        } else if (subscriptionReturn === 'canceled') {
            endCheckoutConfirmation(queryClient)
        }

        const message = subscriptionReturnMessages[subscriptionReturn]
        if (message) {
            toast(message, { type: subscriptionReturn === 'success' ? 'success' : 'blank' })
        }

        searchParams.delete('subscription')
        const search = searchParams.toString()
        navigate(
            {
                pathname: location.pathname,
                search: search ? `?${search}` : '',
                hash: location.hash,
            },
            { replace: true }
        )
    }, [location.hash, location.pathname, location.search, navigate, queryClient])

    return null
}

export default SubscriptionReturnHandler
